export default __webpack_public_path__ + "static/media/azure-pipelines.79e3fc21.svg";